export enum ButtonVariant {
	Primary = "Primary",
	PrimaryOutline = "PrimaryOutline",
	Secondary = "Secondary",
	SecondaryOutline = "SecondaryOutline",
}

// TODO sizes of buttons

export function getButtonClass(variant: ButtonVariant): string {
	// FlyFetch control: athletic, crisp (10px radius, 2px border), sporty spring
	// press, blue focus ring. Blue is the primary action colour (red reads as an
	// error / too aggressive, so it is reserved as a rare accent).
	const commonClassesForLargeButtons = [
		"inline-flex items-center justify-center gap-2 text-center text-base",
		"border-2 rounded-md px-6 md:px-8 py-3 min-h-[3rem] min-w-[12rem] w-fit max-w-[28.75rem]",
		"font-semibold tracking-[0.02em] cursor-pointer select-none",
		"transition-[transform,filter,background-color,border-color,color,box-shadow] duration-150 ease-spring",
		"hover:-translate-y-px active:translate-y-0 active:scale-[0.97]",
		"focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_rgba(58,128,207,0.45)]",
		"disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none disabled:translate-y-0",
	].join(" ");

	switch (variant) {
		case ButtonVariant.Primary:
			return `${commonClassesForLargeButtons} border-transparent bg-secondary text-white shadow-action hover:bg-secondary-600`;
		case ButtonVariant.PrimaryOutline:
			return `${commonClassesForLargeButtons} border-secondary bg-white text-secondary hover:bg-secondary-50 hover:border-secondary-600`;
		case ButtonVariant.Secondary:
			return `${commonClassesForLargeButtons} border-transparent bg-ink-900 text-white shadow-card hover:bg-ink-950`;
		case ButtonVariant.SecondaryOutline:
			return `${commonClassesForLargeButtons} border-ink-300 bg-white text-ink-800 hover:bg-ink-50 hover:border-ink-400`;
	}
}
